import { styled, css } from 'canoe';
import React from 'react';

import { VariableForm, VariableFormProps } from './VariableForm';

const Menu = styled.div`
  ${({ theme }) => css`
    width: 320px;
    border-radius: ${theme.borderRadius.small};
    display: flex;
    align-items: center;
    flex-direction: column;
    overflow: visible;
    background-color: ${theme.colors.OnyxGrayD10};
  `}
`;

interface VariablesPopoutProps {
  variableFormProps: VariableFormProps;
}

export const VariablesPopout = ({ variableFormProps }: VariablesPopoutProps) => {
  return (
    <Menu data-cy="variable-editor">
      <VariableForm {...variableFormProps} />
    </Menu>
  );
};
